import { useAction, useAtom } from '@reatom/npm-react'
import { useParams } from 'react-router'
import styled from 'styled-components'

import { walletsByIdAtom } from '@root/entities/wallet'
import { goBackAction } from '@root/features/routing/atoms'
import { WalletSwap } from '@root/features/trade/wallet-swap/ui/common'

import { WalletSwapHeader } from './wallet-swap-header'

import type { WalletId } from '@root/entities/wallet/model'

type WalletSwapPageProps = {}

export const WalletSwapPage: React.FC<WalletSwapPageProps> = () => {
  const { walletId } = useParams<{ walletId: WalletId }>()
  const goBack = useAction(goBackAction)

  const [wallet] = useAtom((ctx) => {
    if (!walletId) {
      return undefined
    }
    const walletsById = ctx.spy(walletsByIdAtom)
    return walletsById.get(walletId)
  })

  if (!wallet) {
    return undefined
  }

  return (
    <Root>
      <WalletSwapHeader wallet={wallet} onBack={goBack} />
      <WalletSwap wallet={wallet} />
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  background: var(--background-1);
  grid-template-rows: auto minmax(0, 1fr);
  padding-inline: 12px;
  padding-bottom: var(--safe-bottom);
`
